
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetowaipanchgani() {



    const cardData =
    {
        keyword: 'Pune To Wai - Panchgani',
        heading: 'Mauli Cabs: Pune To Wai - Panchgani',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Wai - Panchgani cab services, ensuring a smooth and scenic journey to these beautiful hill stations. Whether you are visiting for a peaceful getaway, a family vacation, or to explore the lush landscapes, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Wai and Panchgani.',

        top: 'Top Places to Visit in Panchgani with Mauli Cabs',

"topPlaces": [
    {
        "title": "Table Land",
        "description": "Table Land is the second-longest mountain plateau in Asia, located at an elevation of 1,387 meters above sea level. It offers panoramic views of the surrounding valleys and hills, making it a popular spot for picnics and paragliding."
    },
    {
        "title": "Sydney Point",
        "description": "Situated approximately 2 km from the Panchgani bus stand, Sydney Point offers a breathtaking view of the Krishna Valley and the Dhom Dam. It's an ideal spot for sunset photography and leisurely walks."
    },
    {
        "title": "Kate's Point",
        "description": "Located about 9 km from Panchgani, Kate's Point provides stunning views of the Krishna Valley, Dhom Dam, and the surrounding hills. It's named after the daughter of then British Governor Sir John Malcolm."
    },
    {
        "title": "Parsi Point",
        "description": "Situated on the Mahabaleshwar road, Parsi Point offers a scenic view of the Krishna Valley and the Dhom Dam backwaters. It's a popular spot for picnics and photography."
    },
    {
        "title": "Dhom Dam",
        "description": "Dhom Dam is a gravity dam located on the Krishna River near Wai, approximately 21 km from Panchgani. It's a serene spot for boating and enjoying the natural beauty of the surroundings."
    },
    {
        "title": "Rajpuri Caves",
        "description": "Rajpuri Caves are ancient caves located near Panchgani. The caves are surrounded by lakes and are believed to have been used by the Pandavas during their exile, adding a mystical charm to the site."
    },
    {
        "title": "Mapro Garden",
        "description": "Mapro Garden is a popular tourist attraction known for its strawberry production and delicious fruit-based products. The garden features a restaurant, nursery, and a retail outlet selling Mapro products."
    },
    {
        "title": "Devrai Art Village",
        "description": "Devrai Art Village is a cultural center dedicated to preserving and promoting traditional Warli tribal art. Visitors can explore the gallery, participate in workshops, and purchase handmade art pieces."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is located on the Mahabaleshwar-Pune road and offers a picturesque view of the surrounding landscape. The waterfall is a popular spot for nature lovers and photographers."
    },
    {
        "title": "Panchgani's Strawberry Farms",
        "description": "Panchgani's strawberry farms are famous for their fresh and delicious strawberries. Visitors can enjoy strawberry picking, taste fresh strawberries, and purchase strawberry-based products."
    }
],

"services": [
    {
        "name": "Pune to Wai - Panchgani Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable taxi services for your journey from Pune to Wai and Panchgani. Experience a smooth ride to these beautiful hill stations."
    },
    {
        "name": "Book Pune to Wai - Panchgani Taxi",
        "description": "Book your taxi from Pune to Wai and Panchgani with Mauli Cabs for a hassle-free and enjoyable trip. Our well-maintained vehicles ensure a comfortable journey."
    },
    {
        "name": "Affordable Pune to Wai - Panchgani Cab",
        "description": "Mauli Cabs provides affordable taxi services for your Pune to Wai and Panchgani trip. Enjoy a budget-friendly yet comfortable ride to these picturesque hill stations."
    },
    {
        "name": "Private Taxi for Wai - Panchgani from Pune",
        "description": "Choose a private taxi service from Pune to Wai and Panchgani with Mauli Cabs. Enjoy a personalized, comfortable ride with a professional driver for a stress-free experience."
    },
    {
        "name": "Wai - Panchgani Trip by Cab from Pune",
        "description": "Mauli Cabs offers dedicated cab services for your Wai and Panchgani trip from Pune. Travel with comfort and ease, ensuring a pleasant journey to these popular destinations."
    },
    {
        "name": "Pune to Wai - Panchgani One-Way or Round Trip",
        "description": "Mauli Cabs offers one-way and round-trip services for your Pune to Wai and Panchgani travel. Choose the best option that suits your schedule and enjoy a comfortable ride."
    },
    {
        "name": "Comfortable Taxi Ride to Wai - Panchgani",
        "description": "Enjoy a comfortable and relaxing taxi ride from Pune to Wai and Panchgani with Mauli Cabs. Our fleet of well-maintained vehicles ensures a smooth journey."
    },
    {
        "name": "Group Travel to Wai - Panchgani",
        "description": "Travel with your group from Pune to Wai and Panchgani in comfort. Mauli Cabs provides spacious vehicles to ensure everyone travels together comfortably."
    },
    {
        "name": "Luxury Taxi for Wai - Panchgani Trip",
        "description": "Experience luxury while traveling from Pune to Wai and Panchgani with Mauli Cabs. Choose from our premium fleet for a stylish and comfortable journey."
    },
    {
        "name": "Wai - Panchgani Sightseeing by Taxi",
        "description": "Mauli Cabs offers sightseeing tours of Wai and Panchgani from Pune. Explore the scenic beauty of these hill stations with a dedicated taxi service."
    }
],

"tableData": [
    ["Pune to Wai - Panchgani Cab Service", "Book Pune to Wai - Panchgani Taxi"],
    ["Affordable Pune to Wai - Panchgani Cab", "Private Taxi for Wai - Panchgani from Pune"],
    ["Wai - Panchgani Trip by Cab from Pune", "Pune to Wai - Panchgani One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Wai - Panchgani", "Group Travel to Wai - Panchgani"],
    ["Luxury Taxi for Wai - Panchgani Trip", "Wai - Panchgani Sightseeing by Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Wai - Panchgani journey. Whether you're visiting for sightseeing, nature walks, or a peaceful getaway, our drivers ensure you reach your destination on time and without hassle."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Wai - Panchgani trip, we provide a wide range of comfortable vehicles including sedans, SUVs, and premium cars. All vehicles are well-maintained, air-conditioned, and spacious, ensuring you a smooth and comfortable ride amidst the scenic beauty."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the best routes to Wai and Panchgani. They are dedicated to providing a safe, efficient, and enjoyable journey, allowing you to relax and enjoy the picturesque landscapes along the way."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Wai - Panchgani trip. We believe in clear pricing with no hidden charges, ensuring that you get the best value for your money during your trip to these serene hill stations."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and peaceful journey to Wai and Panchgani."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Wai - Panchgani trip. Whether you need an early morning ride or a late-night return, our customer service team is always ready to assist you in booking your ride at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Wai - Panchgani cab with Mauli Cabs is simple and convenient. You can easily book online through our website or mobile app, or contact our customer service team for personalized assistance and a smooth booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Wai - Panchgani trip. Whether you're visiting for sightseeing, a weekend getaway, or a relaxing retreat, we can tailor the trip to suit your preferences and needs."
    }
]






















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Wai - Panchgani with Mauli Cabs?',
            answer: 'Booking your cab for a trip from Pune to Wai - Panchgani is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Wai/Panchgani as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Wai - Panchgani trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Wai - Panchgani, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Wai - Panchgani trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Wai - Panchgani take?',
            answer: 'The journey from Pune to Wai - Panchgani typically takes around 3 to 3.5 hours, depending on traffic conditions. Our drivers ensure a smooth and scenic drive, allowing you to enjoy the beautiful landscapes along the way.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Wai - Panchgani route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Wai - Panchgani route and are familiar with the best roads to ensure a safe and timely journey. They prioritize your comfort and safety throughout the trip.',
        },
        {
            question: 'Can I book a round trip for the Pune to Wai - Panchgani trip?',
            answer: 'Yes, you can easily book a round trip to Wai and Panchgani. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Wai - Panchgani?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing or taking breaks along the way. Whether you want to visit specific spots like Table Land in Panchgani or the historic Wai temples, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride during your journey to Wai and Panchgani.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Wai - Panchgani trip?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your trip to Wai and Panchgani is smooth, comfortable, and enjoyable, with a focus on customer satisfaction.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Nitin Sharma",
            position: "Vacation Traveler",
            text: "My trip from Pune to Wai and Panchgani with Mauli Cabs was wonderful! The driver was friendly, the car was clean and comfortable, and the entire journey was smooth. I could enjoy the scenic beauty along the way. Highly recommend them for a relaxing trip!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Anjali Deshmukh",
            position: "Leisure Traveler",
            text: "Mauli Cabs made my visit to Wai and Panchgani so much more enjoyable. The driver was professional, the vehicle was comfortable, and I could relax and enjoy the sights. I will definitely book with Mauli Cabs again for my future trips!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Wai - Panchgani Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Wai - Panchgani. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Wai - Panchgani with 24x7 online booking support, perfect for sightseeing and exploring the area.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Wai - Panchgani Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Wai - Panchgani cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking, perfect for sightseeing in Wai and Panchgani."
        />
        <meta
          name="keywords"
          content="Pune to Wai - Panchgani cab service, Book Pune to Wai - Panchgani taxi, Affordable Pune to Wai - Panchgani cab, Private taxi for Wai - Panchgani from Pune, Wai - Panchgani trip by cab from Pune, Pune to Wai - Panchgani one-way or round trip, Comfortable taxi ride to Wai - Panchgani, Group travel to Wai - Panchgani, Luxury taxi for Wai - Panchgani trip, Wai - Panchgani sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetowaipanchgani;